import React from 'react';

// Design System Components
import Search from 'Components/DesignSystem/Search/Search';

// Constants
import { STRINGS } from '../../../constants';

interface PaneSearchBlockProps {
  searchTerm: string;
  onSearchChange: (searchTerm: string) => void;
}

/**
 * The configuration pane's **top block**: the field search, above every labelled
 * section, closed by a bottom border (spec R62, R79, R81).
 *
 * It is the pane's own block rather than a section's, which is the panel anatomy the
 * incumbent builder uses — search first, labelled sections after — and it makes the
 * search the first control a keyboard user reaches inside the pane.
 *
 * A render position, nothing more: the term and the filtering live where they always
 * did (`CardEditor` owns the term, `selectVisibleFields` applies it), so what the
 * search *does* is unchanged (spec R40).
 */
const PaneSearchBlock = ({ searchTerm, onSearchChange }: PaneSearchBlockProps) => (
  <div className="tw-p-3 tw-border-b tw-border-edge">
    <Search
      placeholder={STRINGS.pane.fieldSearchPlaceholder}
      value={searchTerm}
      onChange={onSearchChange}
      size="small"
      variant="bordered"
    />
  </div>
);

export default PaneSearchBlock;
